import { getLocale } from "../runtime";

const da_trackorderloading = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Henter sporingsinformation...`
};

const en_trackorderloading = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Retrieving tracking information...`
};

const es_trackorderloading = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Recuperando información de seguimiento...`
};

const fi_trackorderloading = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Noudetaan seurantatietoja...`
};

const nb_trackorderloading = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Henter sporingsinformasjon...`
};

const sv_trackorderloading = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Hämtar spårningsinformation...`
};

const trackorderloading = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "da") return da_trackorderloading(inputs)
	if (locale === "en") return en_trackorderloading(inputs)
	if (locale === "es") return es_trackorderloading(inputs)
	if (locale === "fi") return fi_trackorderloading(inputs)
	if (locale === "nb") return nb_trackorderloading(inputs)
	if (locale === "sv") return sv_trackorderloading(inputs)
	return "trackOrderLoading";
};

export { trackorderloading as "trackOrderLoading" };